<template>
    <label :class="{ 'checked': isChecked }">
        <input type="checkbox" :name="name" :value="type" v-model="isChecked" :id="type" @click="change"/>
        <span>{{ $t(type) }}</span>
    </label>
</template>

<script>
  import {EventBus} from "../../services/eventBus";

  export default {
    name: "checkbox",
    props: {
      name: String,
      type: String,
      checked: Boolean,
      group: String,
      filtergroup: String,
      filterId: String
    },
    data () {
      return {
        isChecked: false,
        fCheck: ''
      }
    },
    methods: {
      change() {
        let filter = {filtergroup: this.filtergroup, group:this.group, value: this.name, checked: !this.isChecked, filterId: this.filterId}
        //console.log(filter)
        EventBus.$emit('setFilter', filter)
      }
    },
    mounted () {
      this.isChecked = this.checked
    },
    watch: {
      checked: function() {
        this.checked = this.isChecked
        }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/elements/CheckboxFilter.vue